module.exports = __webpack_public_path__ + "img/activecreateresume.2fe6d79e.svg";